import { allTrackers } from "app/services/track/track";

import createDownloadExtensionTrackingService from "./factory";

const downloadExtensionTrackingService = createDownloadExtensionTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);

export default downloadExtensionTrackingService;
